import Logo from "@/assets/svg/Logo";
import { ArrowLeft } from "lucide-react";
import React from "react";

/** header: "logo" | "back" — parent decides (e.g. org admin on website step gets back to LLM). */
const NewUserOnboardingLayout = ({
  children,
  header = "logo",
  onBack,
}) => {
  return (
    <div className="flex max-w-[620px] w-full mx-auto h-full items-center justify-center">
      <div className="flex flex-col gap-16 w-full">
        {header === "back" && typeof onBack === "function" ? (
          <button
            type="button"
            onClick={onBack}
            className="flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-700"
          >
            <ArrowLeft className="w-4 h-4" />
            Back
          </button>
        ) : (
          <Logo />
        )}
        <div className="bg-transparent">{children}</div>
      </div>
    </div>
  );
};

export default NewUserOnboardingLayout;
